import { type ReactNode, useState } from 'react';

import type { AirplaneInit } from '@/store.js';
import { useMemoizedFn } from 'ahooks';

import EditForm from './EditForm.jsx';

const useEdit = () => {
  const [placeholder, setPlaceholder] = useState<ReactNode | null>(null);

  const show = useMemoizedFn(
    (props: { defaultValue?: AirplaneInit; id?: string; planId: string }) => {
      setPlaceholder(
        <EditForm
          {...props}
          onClose={() => {
            setPlaceholder(null);
          }}
        />
      );
    }
  );

  return { placeholder, show };
};

export default useEdit;
